/**
 * Integrations route — redirects to Tools page (content merged).
 */

import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/docs/integrations")({
	beforeLoad: () => {
		throw redirect({ to: "/docs/skills" });
	},
});
